/**
      *********************************************************
      Description: Switch component.
      Required props:  type, value
      limitations    : N/A
      *********************************************************
**/
import React, { Component, Fragment } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import FormLabel from '@material-ui/core/FormLabel'
import { Typography, Tooltip } from '@material-ui/core'
import { green, red } from '@material-ui/core/colors';
import FormControl from '@material-ui/core/FormControl';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import DefaultSettings from './settings';

const styles = {
    root: {
        flexGrow: 1,
    },
};

const GreenSwitch = withStyles({
    switchBase: {
        color: red[800],
        '&$checked': {
            color: green[700],
        },
        '&$checked + $track': {
            backgroundColor: green[700],
        },
    },
    checked: {},
    track: {},
})(Switch);

const FormSwitch = (props) => {
    const { handleFieldValue, value, name, error, label, tooltip, contexthelp, extraProps, disabled, edit, conditions, helperText, required } = props;
    const { transformProps } = extraProps
    let disabledstatus = conditions && conditions.enable ? conditions.enable : disabled;
    const handlefieldchange = (e) => {
        const { name, checked } = e.target
        let value = transformProps[checked]
        const { dataset } = e.currentTarget;
        handleFieldValue({ target: { name: name, value: value, checked: checked }, currentTarget: { dataset: dataset } })
    }
    let tlabel = (tooltip || contexthelp) ? <Typography variant='subtitle2' style={{ color: props.errors ? 'red' : disabled ? disabled : 'black' }}> {label}&nbsp; < Tooltip title={tooltip ? tooltip : null} placement="bottom-start" >
        <HelpOutlineIcon fontSize="small" style={{ width: '0.8em', color: '#007bff' }} onClick={(evt) => contexthelp ?
            DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
    </Tooltip> </Typography> : label;
    return (
        <Fragment>
            <FormControl required={props.required} error={error || false}>
                <FormControlLabel
                    control={
                        <GreenSwitch
                            checked={value ? (transformProps ? transformProps[value] : value) : false}
                            onChange={handlefieldchange}
                            name={name}
                            disabled={disabledstatus || false}
                        />
                    }
                    label={tlabel || ''}
                />
                {error && <FormLabel >{helperText}</FormLabel>}
            </FormControl>
        </Fragment>
    );
}


export default withStyles(styles)(FormSwitch);